import { ButtonsContainerProps } from "components/buttons/buttonsContainer"
import { Colors } from "styles/colors"

export const buttons1: ButtonsContainerProps[] = [
    {
       title: 'Aptargroup<br/>& Aptar<br/>Beauty',
       titleForCrumb: 'Aptargroup & Aptar Beauty',
       titleColor: Colors.white,
       bckType: 'color',
       background: Colors.gris1,
       border: `${Colors.white} 1px solid`,
       borderRadius: '12px',
       page: '/accueil/groupe',
       right: '600px',
       delay: 0,
       size: '200px',
    },
    {
       title: 'Le site<br/>Les métiers<br/>Les services',
       titleForCrumb: 'Le site Les métiers Les services',
       titleColor: Colors.white,
       bckType: 'color',
       background: Colors.gris1,
       border: `${Colors.white} 1px solid`,
       borderRadius: '12px',
       page: '/accueil/siteNeubourg',
       top: '-600px',
       delay: 0,
       size: '200px',
    },
    {
       title: 'Nos clients<br/>Nos produits',
       titleForCrumb: 'Nos clients Nos produits',
       titleColor: Colors.white,
       bckType: 'color',
       background: Colors.gris1,
       border: `${Colors.white} 1px solid`,
       borderRadius: '12px',
       page: '/accueil/nosClientsNosProduits',
       left: '600px',
       delay: 0,
       size: '200px',
    },
 ]

 //#region MOULAGE
export const buttons2_moulage = [
    {
       title: 'Moulage',
       title2: 'Manuel opérateur /<br/> Qualité',
       titleForCrumb: 'Informations RH et intégration',
       titleColor: Colors.white,
       bckType: 'color',
       background: Colors.gris1,
       border: `${Colors.white} 1px solid`,
       borderRadius: '12px',
       page: '/accueil/moulage',
       right: '600px',
       delay: 100,
       size: '200px',
    },
    {
        title: 'Informations<br/>RH et<br/>intégration',
        titleForCrumb: 'Informations RH et intégration',
        titleColor: Colors.white,
        bckType: 'color',
        background: Colors.gris1,
        border: `${Colors.white} 1px solid`,
        borderRadius: '12px',
        page: '/accueil/informations',
        right: '600px',
        delay: 100,
        size: '200px',
     },
    {
       title: 'Hygiène<br/>Sécurité<br/>Environnement<br/>(HSE)',
       titleForCrumb: 'Hygiène Sécurité Environnement (HSE)',
       titleColor: Colors.white,
       bckType: 'color',
       background: Colors.gris1,
       border: `${Colors.white} 1px solid`,
       borderRadius: '12px',
       page: '/accueil/hse',
       delay: 100,
       size: '200px',
    },
 ].filter(Boolean)
export const buttons3_moulage = [
    {
        title: 'Qualité',
        titleForCrumb: 'Qualité',
        titleColor: Colors.white,
        bckType: 'color',
        background: Colors.gris1,
        border: `${Colors.white} 1px solid`,
        borderRadius: '12px',
        page: '/accueil/qualite',
        left: '600px',
        delay: 100,
        size: '200px',
     },
    {
       title: 'Plan du site <br> Salles de réunion',
       title2: 'Menu cantine',
       title3: 'L’Aptar MAG’',
       titleForCrumb: "En cas d'urgence",
       titleColor: Colors.white,
       bckType: 'color',
       background: Colors.gris1,
       borderRadius: '12px',
       page: '/accueil/autresInformations',
       right: '600px',
       delay: 200,
       size: '200px',
    },
    {
       title: 'BE LEAN +',
       titleForCrumb: 'Be Lean +',
       titleColor: Colors.white,
       bckType: 'color',
       background: Colors.gris1,
       border: `${Colors.white} 1px solid`,
       borderRadius: '12px',
       page: '/accueil/projets',
       top: '600px',
       delay: 200,
       size: '200px',
    },
 ]
export const buttons4_moulage = [
    {
        // title : "Demande<br/>d'infos<br/>Boîte à idées",
        title: '',
        img: 'bouton_suggestion_system_-_v3bis.png',
        titleForCrumb: 'Suggestion System',
        titleColor: Colors.white,
        bckType: 'color',
        background: Colors.gris1,
        border: `${Colors.white} 1px solid`,
        borderRadius: '12px',
        page: '/accueil/formulaire',
        left: '600px',
        delay: 200,
        size: '200px',
     },
    {
       title: "En cas<br/>d'urgence",
       titleForCrumb: "En cas d'urgence",
       titleColor: Colors.white,
       bckType: 'color',
       background: Colors.rouge,
       border: `${Colors.white} 1px solid`,
       borderRadius: '12px',
       page: '/accueil/urgence',
       right: '600px',
       delay: 200,
       size: '200px',
    },
    {
       title: "Astreintes Techniques",
       titleForCrumb: "Astreintes techniques",
       titleColor: Colors.white,
       bckType: 'color',
       background: Colors.rouge,
       border: `${Colors.white} 1px solid`,
       borderRadius: '12px',
       page: '/accueil/astreintes',
       right: '600px',
       delay: 200,
       size: '200px',
    },
 ]

 //#region ASSEMBLAGE
 export const buttons2_assemblage = [
    {
       title: 'Qualité',
       titleForCrumb: 'Qualité',
       titleColor: Colors.white,
       bckType: 'color',
       background: Colors.gris1,
       border: `${Colors.white} 1px solid`,
       borderRadius: '12px',
       page: '/accueil/qualite',
       left: '600px',
       delay: 100,
       size: '200px',
    },
    {
       title: 'Hygiène<br/>Sécurité<br/>Environnement<br/>(HSE)',
       titleForCrumb: 'Hygiène Sécurité Environnement (HSE)',
       titleColor: Colors.white,
       bckType: 'color',
       background: Colors.gris1,
       border: `${Colors.white} 1px solid`,
       borderRadius: '12px',
       page: '/accueil/hse',
       delay: 100,
       size: '200px',
    },
    {
       title: 'Informations<br/>RH et<br/>intégration',
       titleForCrumb: 'Informations RH et intégration',
       titleColor: Colors.white,
       bckType: 'color',
       background: Colors.gris1,
       border: `${Colors.white} 1px solid`,
       borderRadius: '12px',
       page: '/accueil/informations',
       right: '600px',
       delay: 100,
       size: '200px',
    },
 ].filter(Boolean)
 export const buttons3_assemblage = [
    {
       title: 'Plan du site <br> Salles de réunion',
       title2: 'Menu cantine',
       title3: 'L’Aptar MAG’',
       titleForCrumb: "En cas d'urgence",
       titleColor: Colors.white,
       bckType: 'color',
       background: Colors.gris1,
       borderRadius: '12px',
       page: '/accueil/autresInformations',
       right: '600px',
       delay: 200,
       size: '200px',
    },
    {
       title: 'BE LEAN +',
       titleForCrumb: 'Be Lean +',
       titleColor: Colors.white,
       bckType: 'color',
       background: Colors.gris1,
       border: `${Colors.white} 1px solid`,
       borderRadius: '12px',
       page: '/accueil/projets',
       top: '600px',
       delay: 200,
       size: '200px',
    },
    {
       // title : "Demande<br/>d'infos<br/>Boîte à idées",
       title: '',
       img: 'bouton_suggestion_system_-_v3bis.png',
       titleForCrumb: 'Suggestion System',
       titleColor: Colors.white,
       bckType: 'color',
       background: Colors.gris1,
       border: `${Colors.white} 1px solid`,
       borderRadius: '12px',
       page: '/accueil/formulaire',
       left: '600px',
       delay: 200,
       size: '200px',
    },
 ]
 export const buttons4_assemblage = [
    {
       title: "En cas<br/>d'urgence",
       titleForCrumb: "En cas d'urgence",
       titleColor: Colors.white,
       bckType: 'color',
       background: Colors.rouge,
       border: `${Colors.white} 1px solid`,
       borderRadius: '12px',
       page: '/accueil/urgence',
       right: '600px',
       delay: 200,
       size: '200px',
    },
    {
       title: "Astreintes Techniques",
       titleForCrumb: "Astreintes techniques",
       titleColor: Colors.white,
       bckType: 'color',
       background: Colors.rouge,
       border: `${Colors.white} 1px solid`,
       borderRadius: '12px',
       page: '/accueil/astreintes',
       right: '600px',
       delay: 200,
       size: '200px',
    },
 ]